export default "__VITE_ASSET__CxuHnjjU__"